import React from "react";
import {Provider} from "react-redux";
import {ThemeProvider} from "@emotion/react";
import {GoogleOAuthProvider} from "@react-oauth/google";

import {DSThemeProvider, IThemeRP, themeRP} from "@pg-design/themes";
import {FeatureFlagsProvider, IResolvedFeatureFlags} from "@pg-mono/amplitude";
import {WeglotContextProvider} from "@pg-mono/i18n";
import {UserDeviceProvider} from "@pg-mono/user-device";

import {GOOGLE_OAUTH_CLIENT_ID} from "../auth/utils/social_auth_config";
import {RpStore} from "../store/store";
import {isDevelopment, weglotApiKey} from "./read_rp_environment_variables";

interface IProps {
    children: React.ReactNode;
    store: RpStore;
    userAgent?: string;
    featureFlags?: IResolvedFeatureFlags;
}

declare module "@emotion/react" {
    export interface Theme extends IThemeRP {}
}

export const RpCommonProviders: React.FC<IProps> = (props) => {
    return (
        <Provider store={props.store}>
            <DSThemeProvider>
                <ThemeProvider theme={themeRP}>
                    <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
                        <UserDeviceProvider userAgent={props.userAgent}>
                            <WeglotContextProvider
                                apiKey={weglotApiKey}
                                excludedTranslationBlocks={[{value: "#offers-panel-region"}, {value: ".bt"}]}
                                isDevelopment={isDevelopment}
                            >
                                <FeatureFlagsProvider flags={props.featureFlags ?? {}}>{props.children}</FeatureFlagsProvider>
                            </WeglotContextProvider>
                        </UserDeviceProvider>
                    </GoogleOAuthProvider>
                </ThemeProvider>
            </DSThemeProvider>
        </Provider>
    );
};
